import { Component, OnInit } from '@angular/core';
import { TemplateService } from '../shared/services/template.service';
import { DealerService } from '../shared/services/dealer.service';
import {
  ActivatedRoute,
  NavigationStart,
  Router,
  UrlTree,
} from '@angular/router';
import { filter } from 'rxjs/operators';

export type HeaderType =
  | 'header-default'
  | 'header-primary'
  | 'header-info'
  | 'header-success'
  | 'header-danger'
  | 'header-dark';
export type SideNavType = 'sidenav-default' | 'side-nav-dark';

@Component({
  selector: 'app-dashboard',
  templateUrl: './common-layout.component.html',
})
export class CommonLayoutComponent implements OnInit {
  headerThemes = [
    'header-default',
    'header-primary',
    'header-info',
    'header-success',
    'header-danger',
    'header-dark',
  ];
  sidenavThemes = ['sidenav-default', 'side-nav-dark'];
  headerSelected: HeaderType;
  sidenavSelected: SideNavType;
  isCollapse: boolean;
  rtlActived = false;
  themeConfigOpen = false;

  currentDealer = undefined;
  dealers = [];
  routingNum = null;

  private dealer_subscription$;

  constructor(
    private tplSvc: TemplateService,
    public dealerService: DealerService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    this.tplSvc.isSideNavCollapseChanges.subscribe(
      (isCollapse) => (this.isCollapse = isCollapse),
    );

    this.route.firstChild?.paramMap.subscribe(async (params) => {
      this.routingNum = null;
      if (params.has('routingNum')) {
        this.routingNum = params.get('routingNum');
      }

      await this.dealerService.updateRoutingNum(this.routingNum);
    });

    this.route.queryParamMap.subscribe((params) => {
      const admin = params.get('admin');
      if (admin !== this.dealerService.getAdmin()) {
        this.dealerService.setAccess(this.routingNum, admin);
        return;
      }
    });

    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationStart),
        filter((e: NavigationStart) => e.navigationTrigger === 'imperative'),
      )
      .subscribe((e: NavigationStart) => {
        const tree: UrlTree = this.router.parseUrl(e.url);
        const hasAdmin = !!tree.queryParams['admin'];
        const saved = this.dealerService.getAdmin();
        if (saved && saved !== 'NoAccess' && !hasAdmin) {
          tree.queryParams['admin'] = saved;
          this.router.navigateByUrl(tree, { replaceUrl: true });
        }
      });

    this.dealer_subscription$ = this.dealerService.currentDealer$.subscribe(
      (res) => {
        this.currentDealer = res;
        this.dealers = this.dealerService.getAllDealers();
        this.routingNum = this.dealerService.getRoutingNum();
      },
    );
  }

  ngOnDestroy() {
    this.dealer_subscription$.unsubscribe();
  }

  changeDealer(dealer) {
    this.dealerService.setDealer(dealer);
    this.currentDealer = this.dealerService.getDealer();
  }

  changeHeader(headerTheme: HeaderType) {
    this.headerSelected = headerTheme;
  }

  changeSidenav(sidenavTheme: SideNavType) {
    this.sidenavSelected = sidenavTheme;
  }

  toggleThemeConfig() {
    this.themeConfigOpen = !this.themeConfigOpen;
  }
}
